import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';

export default class DateRangeSelector extends React.Component {
    static propTypes = {
        options: PropTypes.array,
        setter: PropTypes.func,
        val: PropTypes.number,
    };

    getLabel = months => {
        if (months < 12) {
            return `${months} MO`;
        }
        return `${months / 12} YR`;
    };

    render() {
        return (
            <div className={`top-0 start-50 ${style.dateBox}`}>
                <nav aria-label="Session navigation">
                    <ul className="pagination list-group list-group-horizontal">
                        {this.props.options.map(option => (
                            <li
                                className={this.props.val === option ? 'active list-group-item' : 'list-group-item'}
                                key={option}
                            >
                                <a
                                    href="#"
                                    onClick={e => this.props.setter(option)}
                                    className={this.props.val === option && style.selectedOption}
                                >
                                    {this.getLabel(option)}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        );
    }
}
